export default "__VITE_ASSET__B5iLx$r9__"